<template>
	<span v-if="svgMarkup" v-html="svgMarkup" :class="wrapperClass" :style="wrapperStyle"></span>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { getSvgIcon, hasIcon, type IconName } from '@monorepo/shared-ui';

interface Props {
	name: IconName;
	size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | number;
	class?: string;
}

const props = withDefaults(defineProps<Props>(), {
	size: 'md',
});

const sizeMap: Record<string, number> = {
	xs: 12,
	sm: 16,
	md: 20,
	lg: 24,
	xl: 32,
	'2xl': 40,
};

const pixelSize = computed(() => {
	if (typeof props.size === 'number') return props.size;
	return sizeMap[props.size] || 20;
});

const svgMarkup = computed(() => {
	if (!hasIcon(props.name)) {
		console.warn(`SvgIcon: Unknown icon "${props.name}"`);
		return '';
	}
	return getSvgIcon(props.name, pixelSize.value);
});

const wrapperClass = computed(() => props.class || '');

const wrapperStyle = computed(() => ({
	display: 'inline-flex',
	alignItems: 'center',
	justifyContent: 'center',
	lineHeight: 0,
}));
</script>
